"use client";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import {
  Autoplay,
  EffectCreative,
  Navigation,
  Pagination,
} from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import CustomImage from "@/components/shared/CustomImage";
import type { Media } from "@/payload-types";
import getImageUrl from "@/utils/getImageUrl";

type Props = {
  images: {
    image?: number | Media | null | undefined;
    id?: string | null | undefined;
  }[];
};

export default function ImageSlide({ images }: Props) {
  if (images && images.length === 0) {
    return <div className="text-center text-white">No slides available.</div>;
  }

  return (
    <div className="container mx-auto aspect-square overflow-hidden md:aspect-video">
      <div className="flex size-full items-center justify-center">
        <Swiper
          effect="slide"
          slidesPerView={1}
          speed={900}
          navigation
          loop
          pagination={{ clickable: true }}
          modules={[EffectCreative, Navigation, Pagination, Autoplay]}
          autoplay={{
            delay: 3000,
          }}
          className="custom-navigation custom-pagination light size-full"
        >
          {images.map(({ image }) => (
            <SwiperSlide key={(image as Media)?.id}>
              <CustomImage
                src={getImageUrl(image as Media)}
                alt={(image as Media)?.alt || "image pension hohenau"}
                fill
                className="size-full object-cover object-center"
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}
